<mat-dialog-content class="p-8">
  <div class="flex flex-row items-start">
    <div class="mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-green-100">
      <mat-icon class="text-green-600 icon-size-5" [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
    </div>

    <div class="flex flex-col">
      <div class="text-xl font-bold text-black">{{ 'ship_interface.manual_entry_of_event_item' | transloco }}</div>

      <div class="text-secondary mt-1">{{ 'ship_interface.you_can_manually_input_timesheet_item_below' | transloco }}</div>
      <div>{{ 'ship_interface.must_only_use_this_function_after_searching_from_the_list' | transloco }}</div>

      <mat-form-field class="mt-2" [subscriptSizing]="'dynamic'">
        <input matInput [formControl]="manualInputControl" [placeholder]="'ship_interface.manual_input_by_selecting_others' | transloco" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="justify-end bg-gray-50 px-4 py-6">
  <button mat-stroked-button class="mr-2" (click)="onCancel()">{{ 'ship_interface.cancel' | transloco }}</button>

  <button mat-flat-button [color]="'primary'" (click)="onSubmit()">{{ 'ship_interface.submit' | transloco }}</button>
</mat-dialog-actions>
